// extracted by mini-css-extract-plugin
export var dropdownButton = "_1x-0";
export var fullWidthDropdownButton = "_1x-1";
export var icon = "_1x-3";
export var iconPlaceholder = "_1x-2";
export var menuItemRow = "_1x-8";
export var separator = "_1x-c";
export var shortcutContainer = "_1x-7";
export var shortcutIconLg = "_1x-6";
export var shortcutIconMd = "_1x-5";
export var shortcutIconSm = "_1x-4";
export var submenuChevron = "_1x-b";
export var submenuDropdown = "_1x-9";
export var submenuTriggerRow = "_1x-a";